<script setup lang="ts">
import MedicationCheckupCopiloteLine from "@/medication-checkup/components/MedicationCheckupCopiloteLine.vue";
import MedicationCheckupUserEcho from "@/medication-checkup/components/MedicationCheckupUserEcho.vue";
import MedicationCheckupCopiloteBubble from "@/medication-checkup/components/MedicationCheckupCopiloteBubble.vue";
import MedicationCheckupSceneReplies from "@/medication-checkup/components/MedicationCheckupSceneReplies.vue";
import {IntroductionView} from "@/medication-checkup/interfaces/introduction";
import {SceneProps} from "@/medication-checkup/composables/useScene";
import {useDoorstepScene} from "@/medication-checkup/composables/useDoorstepScene";

/**
 * The scene of the introduction block: the entry point of the course, the
 * doorstep of the collection interview held with the patient.
 *
 * Everything it shows is served by the handler of the block, in `view`: the
 * text composed from the patient record and the action to take while the
 * consultation has not begun, the frozen record afterwards. The scene owns
 * the rendering only — typing, pacing, the echo of the click — and composes
 * no text of its own.
 */

const props = defineProps<SceneProps<IntroductionView>>();

const {bubbleShown, repliesShown, clicked, text, actions, acted, act} = useDoorstepScene(props);
</script>

<template>
  <div class="flex flex-col gap-3.5">
    <template v-if="frozen">
      <MedicationCheckupCopiloteLine v-if="text" :text="text" />
      <MedicationCheckupUserEcho v-if="acted" :text="acted" />
    </template>

    <template v-else>
      <MedicationCheckupCopiloteBubble
        :shown="bubbleShown"
        :text="text"
      />

      <MedicationCheckupSceneReplies
        :clicked="clicked"
        :actions="actions"
        :shown="repliesShown"
        @act="act"
      />
    </template>
  </div>
</template>
